import { useEffect, useState } from 'react';
import { PERIODICOS_DRAWER_ACTION_VALUES } from '../components/PeriodicosDrawerManager';
import { useLazyGetEmployeesResultsQuery } from '../../../services/periodicosApi';
import useGlobalFilters from '../../../hooks/useGlobalFilters';

export const useResultados = () => {
    const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
    const [open, setOpen] = useState<string>('');

    const {
        clearFilters,
        extraFilters,
        filters,
        setFilters,
        setExtraFilters,
        handleSubmitSearch,
        handleChangeExtraFilters: handleGlobalChangeExtraFilters
    } = useGlobalFilters();

    const [trigger, { data, isFetching }] = useLazyGetEmployeesResultsQuery();

    const handleSearch = async () => {
        try {
            const normalizedExtraFilters = Object.entries(extraFilters || {}).reduce(
                (acc, [key, value]) => {
                    if (value && typeof value === 'object') {
                        const val = value as { id?: number | string; value?: number | string };
                        acc[key] = val.id ?? val.value ?? '';
                    } else {
                        acc[key] = value;
                    }
                    return acc;
                },
                {} as Record<string, any>
            );

            const finalFilters = {
                ...filters,
                ...normalizedExtraFilters
            };

            await trigger(finalFilters).unwrap();
        } catch (err) {
            console.error(err);
        }
    };

    const handleClearFilters = () => {
        clearFilters();
        handleSearch();
    };

    const handleChangeExtraFilters = (newFilters: any) => {
        handleGlobalChangeExtraFilters(newFilters);
    };

    const handleSelectEmployee = (employee: any) => {
        setSelectedEmployee(employee);
    };

    const handleClickAction = (employee: any) => {
        setSelectedEmployee(employee);
    };

    const getUniqueId = (employee: any) => employee?.idEmpleadoExpuesto ?? employee?.id;
    const getColumnWidths = () => ({});

    const reloadGrid = async () => {
        await handleSubmitSearch();
        await handleSearch();
    };

    useEffect(() => {
        handleSearch();
    }, [filters]);

    return {
        clearFilters,
        extraFilters,
        filters,
        setFilters,
        setExtraFilters,
        handleSubmitSearch,
        handleChangeExtraFilters,
        isFetching,
        fetchData: data || [],
        selectedEmployee,
        handleSelectEmployee,
        handleClickAction,
        open,
        setOpen,
        getUniqueId,
        getColumnWidths,
        reloadGrid,
        handleSearch,
        handleClearFilters
    };
};
